import {Button, List, ListItem} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Alert, AlertTitle} from '@material-ui/lab';
import {isSafari} from 'utils/device';
import React from 'react';

const useStyles = makeStyles({
    root: {},
    standardSuccess: {},
    standardInfo: {},
    standardWarning: {},
    standardError: {},
    outlinedSuccess: {},
    outlinedInfo: {},
    outlinedWarning: {},
    outlinedError: {},
    filledSuccess: {},
    filledInfo: {},
    filledWarning: {},
    filledError: {},
    icon: {},
    message: {
        fontSize: '1.25em',
    },
    action: {
        flexBasis: '10em',
    },
});
const StyledAlert = ({children, ...props}) => {
    const styles = useStyles();
    return (
        <Alert
            classes={{
                icon: styles.icon,
                message: styles.message,
                action: styles.action,
            }}
            {...props}
        >
            {children}
        </Alert>
    );
};

const useTitleStyles = makeStyles({
    root: {
        fontSize: '1.2em',
    },
});
const StyledAlertTitle = ({children, ...props}) => {
    const styles = useTitleStyles();
    return (
        <AlertTitle
            classes={{
                root: styles.root,
            }}
            {...props}
        >
            {children}
        </AlertTitle>
    );
};

const ValidationErrorAlert = errors => (
    <StyledAlert severity='error'>
        <StyledAlertTitle>Oops!</StyledAlertTitle>
        Unfortunately, our system has noticed some errors in your paperwork.
        They are listed below. MM-SEAS cannot accept documents with errors. If
        you entered something incorrectly, please go back to correct it.
        Otherwise, please abort this document, fix the error on your paperwork,
        and upload a new photo before trying again.
        {errors && errors.length && (
            <List>
                {errors.map(error => (
                    <ListItem key='error.message'>{error.message}</ListItem>
                ))}
            </List>
        )}
    </StyledAlert>
);

const ReviewAlert = ({title, body}) => (
    <StyledAlert
        severity='info'
        action={
            <Button
                variant='contained'
                disableElevation
                onClick={() => {
                    // There's a better react way to do this, but
                    // This is way faster and shouldn't have issues with shadow dom
                    document
                        .querySelector('[data-cy="form-nav-validate"]')
                        .scrollIntoView(
                            isSafari
                                ? false
                                : {
                                      behavior: 'smooth',
                                      block: 'end',
                                      inline: 'end',
                                  }
                        );
                }}
            >
                I'M READY
            </Button>
        }
    >
        <StyledAlertTitle>{title || "You're almost done!"}</StyledAlertTitle>
        {body ||
            `Please review the information below and ensure it is entered correctly.
            When you're ready, scroll down to validate.`}
    </StyledAlert>
);

const SSLReviewAlert = () => (
    <StyledAlert severity='info'>
        <StyledAlertTitle>Great!</StyledAlertTitle>
        If you have sea service on another vessel, click the button below to add
        another vessel. Otherwise, if you've entered all your vessels, click
        'Next.'
    </StyledAlert>
);

export {
    StyledAlert,
    StyledAlertTitle,
    ValidationErrorAlert,
    ReviewAlert,
    SSLReviewAlert,
};
